export default `
  .font-wl-600 {
    font-style: normal;
    font-weight: 600;
    line-height: 150%;
  }

  .font-wl-700 {
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
  }

  .font-wl-500 {
    font-style: normal;
    font-weight: 500;
    line-height: 120%;
  }

  .font-wl-400 {
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  .font-wl-300 {
    font-style: normal;
    font-weight: 400;
    line-height: 23px;
  }

  .text-xlg {
    font-size: 19px;
  }
  .text-mlg {
    font-size: 18px;
  }
  .text-xg {
    font-size: 17px;
  }

  .text-mg {
    font-size: 16px;
  }

  .text-lg {
      font-size: 15px;
  }

  .text-sm {
      font-size: 14px;
  }

  .text-md {
      font-size: 13px;
  }

  .text-xs {
      font-size: 12px;
  }

  .text-xxs {
      font-size: 10px;
  }
`